import CardList from 'components/desktop/shared/card-list';
import ProjectVerticalCard from 'components/desktop/shared/project-vertical-card';
import { IconBuildingTwo } from 'components/icons';
import { isEmpty, map } from 'lodash';
import { DetailProjectPageContext } from 'pages/du-an/[chi-tiet-du-an]';
import { useContext } from 'react';
import { SwiperSlide } from 'swiper/react';

const RelatedCardList = () => {
  const { relatedProjectsWithPagination } = useContext(DetailProjectPageContext).pageData ?? {};
  const { items: relatedProjects } = relatedProjectsWithPagination ?? {};

  return isEmpty(relatedProjects) ? null : (
    <CardList
      id='related-card-list'
      spaceBetween={0}
      wrapperClassname='min-w-[944px] xl:min-w-[1200px] flex flex-col bg-paper rounded-[16px] space-y-[16px] py-[16px] shadow-1'
      iconComponent={<IconBuildingTwo className='min-h-[24px] min-w-[24px] text-paper' />}
      titleComponent={<h2 className='text-[20px] font-[600] leading-[23px]'>Dự án tương tự</h2>}
      cardListComponent={map(relatedProjects, (relatedProject, relatedProjectIndex) => (
        <SwiperSlide
          key={`${relatedProject?.id}-${relatedProjectIndex}`}
          className='min-w-[464.5px] max-w-[464.5px] px-[8px] py-[16px] xl:min-w-[395px] xl:max-w-[395px]'
        >
          <ProjectVerticalCard project={relatedProject} />
        </SwiperSlide>
      ))}
    />
  );
};

export default RelatedCardList;
